<template>
	<div>
		<titles titlename="班级管理" titlecontent="这里可以管理班级" :mbx="paths"></titles>
		<manges :pagesobj="pagesobj" :tabtitlelist="tabtitlelsit" :mangesname="mangesname" :tablist="tablist"></manges>
	</div>
</template>

<script>
import titles from '@/components/title/title.vue';
import manges from '@/components/mangeslist/manges.vue';
import { GetbjPageClassList } from '@/request/api/mange/mange.js';

import AppOptions from '@/config/AppOptions.vue';
export default {
	data() {
		return {
			pagesobj: {
				pageIndex: 1,
				pageSize: 10,
				pro_name: '',
				maxpages: null,
				cla_name: '',
				si_guid: ''
			},
			mangesname: {
				name: '班级',
				topcolor: '#56B8FF',
				contentcolor: '#FF686D',
				show: false
			},
			tabtitlelsit: [
				{
					label: '班级名称',
					prop: 'cla_name'
				},
				{
					label: '班级编号',
					prop: 'cla_nameNumber'
				},
				{
					label: '所属专业',
					prop: 'pro_name'
				},
				{
					label: '所属院校',
					prop: 'si_name_cn'
				},
				{
					label: '备注',
					prop: 'cla_remark'
				}
			],
			tablist: [],
			// 标题组件
			paths: [
				{
					path: '/basicmanage/classmange',
					name: '班级管理'
				}
			]
		};
	},
	mounted() {
		this.getClassList();
	},
	created() {
		AppOptions.appEmpty = false;
	},
	methods: {
		getClassList(pagecrofobj = null) {
			let MenuListobj = {
				pageIndex: 1,
				pageSize: 10,
				cla_name: '',
				si_guid: ''
			};
			GetbjPageClassList(pagecrofobj == null ? MenuListobj : pagecrofobj).then(res => {
				// console.log(res)
				this.tablist = res.data.data.list;
				this.pagesobj.maxpages = res.data.data.totalCount;
			});
		}
	},
	components: {
		titles,
		manges
	}
};
</script>

<style lang="less">
/deep/ .el-dialog__header {
	padding: 14px 19px 10px;
	background: #05a34a;
	color: #fff;
	font-size: 1.2rem;

	.el-dialog__headerbtn .el-dialog__close {
		color: #fff;
		font-size: 1.4rem;
	}

	.dialog-header-title {
		span {
			margin-left: 0.6rem;
		}
	}
}
</style>
